export default __webpack_public_path__ + "static/video_loop-0a3f06b4628715480514ceb382ef85be.webm";